import { memo } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}
function bookOf(exposures, nat) {
  return roundBook(exposures?.[nat] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

/** Back/Lay pair used by the 4-column card rows and the judgement columns */
function BackLayBox({ item, onBet }) {
  const susp = isSusp(item);
  return (
    <div className="casino-bl-box">
      <div
        className={`back casino-bl-box-item${suspCls(item)}`}
        onClick={susp ? undefined : () => onBet(item.sid, 'back', item.b, item)}
      >
        <span className="casino-box-odd">{item?.b ?? 0}</span>
      </div>
      {' '}
      <div
        className={`lay casino-bl-box-item${suspCls(item)}`}
        onClick={susp ? undefined : () => onBet(item.sid, 'lay', item.l, item)}
      >
        <span className="casino-box-odd">{item?.l ?? 0}</span>
      </div>
    </div>
  );
}

/** Single "back only" bet used in pasa-other-bet rows */
function BackOnlyBox({ item, onBet }) {
  const susp = isSusp(item);
  return (
    <div className="casino-bl-box">
      <div
        className={`back casino-bl-box-item${suspCls(item)}`}
        onClick={susp ? undefined : () => onBet(item.sid, 'back', item.b, item)}
      >
        <span className="casino-box-odd">{item?.b ?? 0}</span>
      </div>
    </div>
  );
}

const BetTableTrio = memo(function BetTableTrio({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});
  const book = (item) => {
    const v = bookOf(exposures, item?.nat);
    return <div className={`casino-nation-name ${bookCls(v)}`}>{fmtBook(v)}</div>;
  };

  const session  = sub.find((s) => s.subtype === 'trio');
  const j124     = sub.find((s) => s.subtype === '124');
  const jqk1     = sub.find((s) => s.subtype === 'jqk1');
  const red2     = sub.find((s) => s.subtype === 'red2');
  const black2   = sub.find((s) => s.subtype === 'black2');
  const odd2     = sub.find((s) => s.subtype === 'odd2');
  const even2    = sub.find((s) => s.subtype === 'even2');
  const pair2    = sub.find((s) => s.subtype === 'pair2');
  const flush    = sub.find((s) => s.subtype === 'flush');
  const straight = sub.find((s) => s.subtype === 'straight');
  const trio1    = sub.find((s) => s.subtype === 'trio1');
  const sf       = sub.find((s) => s.subtype === 'straightflush');

  const sessSupp = isSusp(session);

  return (
    <div className="casino-detail">
      <div className="row row5">
        {/* ── Column 1: Session (col-12 / col-md-6) ── */}
        <div className="col-12 col-md-6">
          <div className="casino-box-row d-none-small" style={{ height: '30px' }}></div>

          <div className="casino-box-row pasa-sesssion">
            <div className="casino-nation-name">
              <b className="pointer">{session?.nat || 'Session'}</b>
              {' '}
              {(() => {
                const v = bookOf(exposures, session?.nat);
                return <div className="float-right"><span className={`mr-2 ${bookCls(v)}`}>{fmtBook(v)}</span></div>;
              })()}
            </div>
            <div className="casino-bl-box">
              {/* LAY first */}
              <div
                className={`lay casino-bl-box-item${suspCls(session)}`}
                onClick={sessSupp ? undefined : () => handleBet(session.sid, 'lay', session.lbhav, session)}
              >
                <span>{session?.l ?? 0}</span>
                <span className="casino-box-odd">{session?.lbhav ?? 0}</span>
              </div>
              {/* BACK second */}
              <div
                className={`back casino-bl-box-item${suspCls(session)}`}
                onClick={sessSupp ? undefined : () => handleBet(session.sid, 'back', session.bbhav, session)}
              >
                <span>{session?.b ?? 0}</span>
                <span className="casino-box-odd">{session?.bbhav ?? 0}</span>
              </div>
            </div>
          </div>

          <div className="casino-box-row d-none-small" style={{ height: '30px' }}></div>
        </div>

        {/* ── Column 2: 3 Card Judgement (1 2 4) ── */}
        <div className="col-6 col-md-3 pasa-fancy">
          <div className="casino-box-row">
            <div className="casino-nation-name">
              <b>{j124?.nat || '3 Card Judgement(1 2 4)'}</b>
            </div>
            <BackLayBox item={j124} onBet={handleBet} />
            {book(j124)}
          </div>
        </div>

        {/* ── Column 3: 3 Card Judgement (J Q K) ── */}
        <div className="col-6 col-md-3 pasa-fancy">
          <div className="casino-box-row">
            <div className="casino-nation-name">
              <b>{jqk1?.nat || '3 Card Judgement(J Q K)'}</b>
            </div>
            <BackLayBox item={jqk1} onBet={handleBet} />
            {book(jqk1)}
          </div>
        </div>
      </div>

      {/* ── Row 2: 4 colour/parity columns ── */}
      <div className="row row5 mt-2 pasa-cards">
        <div className="col-6 col-md-3">
          <div className="casino-box-row">
            <div className="casino-nation-name">
              <b>{red2?.nat || 'Two Red Only'}</b>
            </div>
            <BackLayBox item={red2} onBet={handleBet} />
            {book(red2)}
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="casino-box-row">
            <div className="casino-nation-name">
              <b>{black2?.nat || 'Two Black Only'}</b>
            </div>
            <BackLayBox item={black2} onBet={handleBet} />
            {book(black2)}
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="casino-box-row">
            <div className="casino-nation-name">
              <b>{odd2?.nat || 'Two Odd Only'}</b>
            </div>
            <BackLayBox item={odd2} onBet={handleBet} />
            {book(odd2)}
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="casino-box-row">
            <div className="casino-nation-name">
              <b>{even2?.nat || 'Two Even Only'}</b>
            </div>
            <BackLayBox item={even2} onBet={handleBet} />
            {book(even2)}
          </div>
        </div>
      </div>

      {/* ── Row 3: Other bets (back only, inline) ── */}
      <div className="casino-box-row pasa-other-bets">
        {[
          { item: pair2,    label: 'Pair' },
          { item: flush,    label: 'Flush' },
          { item: straight, label: 'Straight' },
          { item: trio1,    label: 'Trio' },
          { item: sf,       label: 'Straight Flush' },
        ].map(({ item, label }) => (
          <div key={label} className="casino-box-row pasa-other-bet">
            <div className="casino-nation-name">
              <b>{item?.nat || label}</b>
            </div>
            <BackOnlyBox item={item} onBet={handleBet} />
            {book(item)}
          </div>
        ))}
      </div>
    </div>
  );
});

export default BetTableTrio;
